import { inject } from '@angular/core'
import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms'
import { Observable, timer } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { StaffService } from 'src/app/core/services/staff/staff.service'

export function userNameAvailabilityValidator(staffService: StaffService): AsyncValidatorFn {
    return (control: AbstractControl) => {
        return timer(500).pipe(
            switchMap(() =>
                staffService
                    .checkIfUsernameExists(control.value)
                    .pipe(map((result) => (result ? { usernameTaken: true } : null)))
            )
        )
    }
}
